module.exports = __webpack_public_path__ + "img/SVG2_BeforeUbegin.69314998.svg";